'use client';

import Image from 'next/image';
import LinkNoPrefetch from '@/components/link-noprefetch';

import Contentlet from '@/components/shared/contentlet';
import { DotCardImage } from '@/components/shared/dotCardImage';

import { getFirstCategoryName } from '../utils';

import { DotBlockEditor } from '@/components/shared/decodeTextBlock';

/**
 * This component shows the featire Post as the main card
 *
 * @export
 * @param {*} { contentlet }
 * @return {*}
 */
export function FeaturePost({ contentlet }) {
    const { teaser, URL_MAP_FOR_CONTENT, categories, industry, intro } = contentlet;
    const [author] = contentlet.author || [];
    const categoryName = getFirstCategoryName(categories || industry);

    return (
        <Contentlet contentlet={contentlet}>
            <LinkNoPrefetch href={URL_MAP_FOR_CONTENT || '/'}>
                <article
                    className="grid gap-4 py-8 lg:grid-cols-[repeat(auto-fit,minmax(17.5rem,1fr))]"
                    aria-label={`Read more about ${contentlet.title}`}>
                    <div className="relative aspect-video w-full overflow-hidden rounded-lg">
                        <DotCardImage
                            src={contentlet.image}
                            alt={contentlet?.thumbnailAlt || contentlet?.title || 'Blog image'}
                            placeholderFontSize={'4rem'}
                        />
                    </div>
                    <div className="flex h-fit flex-col gap-4 md:min-w-[20.9375rem]">
                        <span className="w-min whitespace-nowrap text-sm text-fuschia-800">
                            {categoryName}
                        </span>
                        <h3 className="text-blue-700">{contentlet.title}</h3>
                        <DescriptionComponent intro={intro} teaser={teaser} />

                        {author && (
                            <div className="relative mt-auto flex h-12 flex-row gap-3">
                                <div className="relative size-12 overflow-hidden rounded-full">
                                    <Image
                                        src={author.identifier}
                                        alt={author.name || 'Author image'}
                                        quality={80}
                                        className="rounded-full object-cover"
                                        width={48}
                                        height={48}
                                    />
                                </div>
                                <div className="flex flex-col justify-center">
                                    <p className="text-sm text-blue-700">
                                        {author.firstName} {author.lastName}
                                    </p>
                                    <p className="text-sm text-blue-600">{author.title}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </article>
            </LinkNoPrefetch>
        </Contentlet>
    );
}

const DescriptionComponent = ({ intro, teaser }) => {
    let blocks = intro;
    if (typeof intro === 'string') {
        try {
            blocks = JSON.parse(intro);
        } catch (e) {
            blocks = null;
        }
    }

    if (blocks) {
        return <DotBlockEditor className="text-sm text-blue-700" blocks={blocks} />;
    }

    return <p className="text-sm text-blue-700">{teaser}</p>;
};
